import { isSameId } from "../../helpers";
import { uid } from "@xbs/lib-state";
export default function (store, ev) {
    const { id, manual = false, skipStateCalc = false } = ev;
    const task = store.getTask(id);
    if (task?.checked)
        return;
    const batch = [];
    const completed = store.getState().taskShape?.completed?.behavior || "auto";
    if (!ev.$meta) {
        ev.$meta = {};
    }
    if (!ev.$meta.batch) {
        ev.$meta.batch = uid();
    }
    const historyBatch = ev.$meta.batch;
    if (!manual && completed !== "manual" && !skipStateCalc) {
        if (store.hasChildren(id)) {
            store.getChildren({ id, tree: true }).forEach(t => {
                if (!t.checked) {
                    store.in.exec("check-task", {
                        id: t.id,
                        skipStateCalc: true,
                        $meta: {
                            batch: historyBatch,
                            skipHistory: !!ev.$meta?.skipHistory,
                        },
                    });
                    batch.push({ ...store.getTask(t.id) });
                }
            });
        }
        const parents = store.getParentIds(id);
        parents.forEach(parentId => {
            const needMarkParent = store
                .getChildren({ id: parentId })
                .every(t => {
                if (isSameId(t.id, id))
                    return true;
                return store.getTask(t.id).checked;
            });
            if (needMarkParent) {
                const parent = store.getTask(parentId);
                if (!parent.checked) {
                    store.in.exec("check-task", {
                        id: parentId,
                        skipStateCalc: true,
                        $meta: {
                            batch: historyBatch,
                            skipHistory: !!ev.$meta?.skipHistory,
                        },
                    });
                    batch.push({ ...store.getTask(parentId) });
                }
            }
        });
    }
    store.in.exec("update-task", {
        id,
        task: {
            ...task,
            checked: true,
            completion_date: new Date(),
        },
        skipStateCalc,
        skipProvider: skipStateCalc && !manual,
        batch,
        $meta: {
            skipHistory: true,
        },
    });
    return () => {
        store.in.exec("uncheck-task", {
            ...ev,
            $meta: {
                ...ev.$meta,
                skipHistory: true,
            },
        });
    };
}
//# sourceMappingURL=check.js.map